import { clearString } from '../assets/constants/strings';
import pluralize from 'pluralize';
import { search } from './axios';
import store from '../store';

export const RGuidesRegex =
  /(regulatory)(\s?(guide))(\s?\d*)?\b|\b(rg)(\s?\d*)?\b|\b(regulatory)(\s?(guide))\b|\b(regulatory(\s?\d*)?)\b|\b(guide(\s?\d*)?)\b(regulatory)(\s?(guide))(\s?\d*)?\b|\b(rg)(\s?\d*)?\b|\b(regulatory)(\s?(guide))\b|\b(regulatory(\s?\d*)?)\b|\b(guide(\s?\d*)?)\b/gi;

/**
 * Refined search algorithm to pick up "RG" if you search for Regulatory Guide
 * @param {string} input The search param.
 * @param {Array<object>} documents The array with all docs.
 * @param {Array<{ key: string; value: string | Date; type: string; active?: boolean }>} filters The filters to perform advanced search.
 * @returns {Array<object>} The Array of matched docs.
 */
export const RGTitleSearch = (input, documents, filters) => {
  let matchedDocs = [];
  if (documents && documents.length > 0) {
    let breakWord = false;

    // const normalizeText = (text) =>
    //   text
    //     .toLowerCase()
    //     .replace(/[^a-z0-9\s]/gi, '') // Remove special characters except spaces
    //     .trim()
    //     .split(/\s+/); // Split by spaces after normalization

    const normalizeText = (text) =>
      text
        .toLowerCase()
        .replace(/[^a-z0-9\s/]/gi, '') // Keep letters, numbers, spaces, and '/'
        .trim()
        .split(/\s+/); // Split by spaces

    const normalizedInput = normalizeText(input); // Normalize the input

    const keysToCheck = [
      'documentId',
      'levelOne',
      'levelTwo',
      'levelThree',
      'levelFour',
    ];

    const hasAllValue =
      filters !== null &&
      filters !== undefined &&
      filters.some(
        (item) => keysToCheck.includes(item.key) && item.value !== '-All-'
      );

    // advanced search
    if (filters && filters.length > 0 && hasAllValue) {
      // filtering logic before normal search regex to increase performance
      filters.forEach((filter) => {
        // if its not the default value
        if (filter.value !== '-All-' && filter.type === 'equal') {
          if (filter.key.match('level')) {
            documents = documents.filter(
              (doc) =>
                doc[filter.key] !== null &&
                doc[filter.key].Title === filter.value
            );
          }
        } else if (filter.type === 'smaller') {
          documents = documents.filter(
            (doc) => doc[filter.key] <= filter.value
          );
        } else if (filter.type === 'larger') {
          documents = documents.filter(
            (doc) => doc[filter.key] >= filter.value
          );
        }
      });

      // then do normal search and add if not already present
      documents.forEach((doc) => {
        const regExWord = new RegExp(
          breakWord ? `(\\b${input}\\b)` : `(${input})`,
          'gi'
        );
        if (
          !matchedDocs.some((Doc) => Doc.id === doc.id) &&
          doc.title.match(regExWord)
        )
          matchedDocs.push(doc);
      });
      return matchedDocs;
    } else {
      const docs = documents.filter((doc) => {
        const normalizedTitle = normalizeText(doc.title); // Normalize the document title
        return normalizedInput.every((inputWord) =>
          normalizedTitle.some((titleWord) => titleWord.includes(inputWord))
        ); // Check if every word in the input is contained in the title
      });
      return docs;
    }
  }
};

export const SearchPHP = async (input, substringSearch) => {
  const inputSingular = pluralize.singular(input.trim());
  const inputPlural = pluralize(input.trim());

  const spKey = store.getState().user.user.spKey;

  return await search(
    {
      singular: inputSingular,
      plural: inputPlural,
      subString: substringSearch,
    },
    spKey
  );
};

export const filterPages = (pages, filters) => {
  // filtering logic
  filters.forEach((filter) => {
    // if its not the default value
    if (filter.value !== '-All-' && filter.type === 'equal') {
      pages = pages.filter((page) => page[filter.key] === filter.value);
    } else if (filter.type === 'smaller') {
      pages = pages.filter((page) => page[filter.key] <= filter.value);
    } else if (filter.type === 'larger') {
      pages = pages.filter((page) => page[filter.key] >= filter.value);
    }
  });

  return pages;
};
